import React from 'react';

import { TextField, InputAdornment } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import {
    getCountryCurrencyDecimalSeparator,
    getCountryCurrencyThousandSeparator,
} from 'common/utils/helpers/session';

const IntlNumberInputField = (props) => {
    const {
        allowDecimals = true,
        allowNegativeValue = true,
        append,
        autoFocus = false,
        dataIntercomTarget,
        decimalsLimit = 16,
        max,
        min,
        onChange,
        onFocus,
        onKeyDown,
        prepend,
        readOnly,
        value,
        ...rest
    } = props;

    const onChangeAction = ({ value }) => {
        const newValue = value === undefined ? '' : value;
        if (getIsAllowedValue({ float: newValue })) onChange(newValue);
    };

    const getIsAllowedValue = ({ floatValue }) => {
        const _min = parseFloat(min);
        const _max = parseFloat(max);
        if (
            (_min && !isNaN(_min) && floatValue < _min) ||
            (_max && !isNaN(_max) && floatValue > _max)
        )
            return false;
        return true;
    };

    return (
        <NumberFormat
            isAllowed={getIsAllowedValue}
            allowNegative={allowNegativeValue}
            autoFocus={autoFocus}
            customInput={TextField}
            data-intercom-target={dataIntercomTarget}
            decimalSeparator={getCountryCurrencyDecimalSeparator()}
            decimalScale={!allowDecimals ? 0 : decimalsLimit}
            InputProps={{
                endAdornment: append && (
                    <InputAdornment position="end">{append}</InputAdornment>
                ),
                readOnly: readOnly,
                startAdornment: prepend && (
                    <InputAdornment position="start">{prepend}</InputAdornment>
                ),
            }}
            isNumericString
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            onValueChange={onChangeAction}
            thousandSeparator={getCountryCurrencyThousandSeparator()}
            value={value}
            {...rest}
        />
    );
};

IntlNumberInputField.propTypes = {
    allowDecimals: PropTypes.bool,
    allowNegativeValue: PropTypes.bool,
    append: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    autoFocus: PropTypes.bool,
    dataIntercomTarget: PropTypes.string,
    decimalsLimit: PropTypes.number,
    max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxLength: PropTypes.number,
    min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    prepend: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    readOnly: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default IntlNumberInputField;
